import {useState} from "react"

import {DBModel, FilterByType, PagingType, SortByType} from "@backend/types"
import {IApiCalls} from "@libs/ClientService"


type FilterChangeProps = {
    searchText?: string,
    sortBy?: SortByType[],
    filterBy?: FilterByType[],
    selected?: number

}

export function useFilter<Type extends DBModel>(apiCalls: IApiCalls<Type>) {

    const [filter, setFilter] = useState<{
        isLoading?: boolean;
        query?: {
            placeId?: string,
            searchText?: string,
            find?: any,
            page?: number,
            sortBy?: SortByType[]
        },
        meta?: string,
        results?: PagingType<Type>
    } | null>()

    function resetFilter() {
        setFilter(null)
    }

    function onFilterChange(props: FilterChangeProps = {}) {
        const {selected = 0, ...options} = props
        apiCalls.listWithPager({}, {...(filter?.query || {}), ...options, page: selected + 1})
            .then(results => {
                setFilter({
                    isLoading: false,
                    query: {
                        ...(filter?.query || {}),
                        ...options,
                        page: selected
                    },
                    meta: filter?.meta,
                    results
                })
            })

    }

    return {
        filter,
        setFilter,
        resetFilter,
        onFilterChange
    }
}